/**
 * Diagnosis Service
 * Patient diagnosis tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { DiagnosisGroupsControllerGetById200Response } from '../model/diagnosisGroupsControllerGetById200Response';
// @ts-ignore
import { DiagnosisGroupsControllerList200Response } from '../model/diagnosisGroupsControllerList200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisGroupsService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Get diagnosis group by ID
   * @param id 
   */
  public async diagnosisGroupsControllerGetById(id: string, ): Promise<DiagnosisGroupsControllerGetById200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling diagnosisGroupsControllerGetById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnosis/groups/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List diagnosis groups
   * @param status Filter by status
   * @param name Search by name (partial match)
   * @param offset Page offset
   * @param limit Page limit
   * @param orderBy Field to sort by
   * @param orderDirection Sort direction
   */
  public async diagnosisGroupsControllerList(status?: string, name?: string, offset?: number, limit?: number, orderBy?: 'name' | 'createdOn', orderDirection?: 'ASC' | 'DESC', ): Promise<DiagnosisGroupsControllerList200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters.append('name', String(name));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters.append('orderBy', String(orderBy));
    }
    if (orderDirection !== undefined && orderDirection !== null) {
      localVarQueryParameters.append('orderDirection', String(orderDirection));
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnosis/groups?${queryString}` : `${this.configuration.basePath}/api/forthbridge-diagnosis/diagnosis/groups`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
